<template>
	<div>
		<div class="news-item" @click="onToWebView()">
			<div class="news-top flex-between" >
				<div v-if="!row" class="news-type">{{row.cate_list[0].name}}</div>
				<div v-else :class="row.type=='pic' ? 'news-type-pic news-type':'news-type-video news-type'">资讯</div>
				<div class="news-read-count">{{row.views_count}}阅读</div>
			</div>
			<div class="news-main">
				<div class="news-titel-box flex-start">
					<div class="new-title-left">
						<img style="width: .17rem;height: .12rem;" src="../../assets/images/other/icon-yinhao-1.png" />
					</div>
					<div class="new-title-right on-show-two">
						{{row.title}}
						<img class="title-right-img" style="width: .17rem;height: .12rem;"  src="../../assets/images/other/icon-yinhao-2.png"  />
					</div>
				</div>
				<div style="width:3.25rem;height: 2.91rem;position: relative;">
					<img style="width:3.25rem;height:  2.91rem;border-radius: .16rem;" :src="row.pic_url" />
					<div class="pics-length">{{row.pics_url.length}}张</div>
					<div class="play-btn" v-if="false">
						<img style="width: .58rem; height: .58rem;"  src="../../assets/images/other/icon-playbtn.png"  />
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		name: "NewsItem",
		components: {},
		props: {
			row: {
				type: Object,
				default: {}
			},
		},

		data: function() {
			return {
				duration: 300
			};
		},
		mounted() {
			// console.log(this.row)
		},
		methods: {
			onToWebView() {
				// uni.navigateTo({
				// 	url: '/pages/apps/news/NewsDetail/NewsDetail?url=https://h5.ccago.cn/cca-h5/dist/news-detail?' +
				// 		qs.stringify({
				// 			id: this.row.id
				// 		})
				// })

        rbLink({
          name: 'NewsDetail',
          query: {
            id:this.row.id
          }
        })
			},

			onRbLink(item) {

				rbLink({
					name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
					query: item.url.query
				});
			}
		},

		filters: {}
	};
</script>

<style scoped>
	.play-btn {
		width: .58rem;
		height: .58rem;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	.pics-length {
		height: .28rem;
		font-size: .2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: .28rem;
		padding: 0.01rem 0.08rem;
		background: rgba(0, 0, 0, 0.46);
		border-radius: .17rem;
		position: absolute;
		bottom: .28rem;
		right: .11rem;

	}

	.news-titel-box {
		align-items: flex-start !important;
	}

	.title-right-img {
		position: absolute;
		bottom: .3rem;
		right: .1rem;
	}

	.new-title-left {
		display: flex;
		align-items: flex-start;
		margin-top: 0.05rem;
		margin-right: .1rem;

	}

	.new-title-right {
		background-size: .17rem .12rem;
		background-repeat: no-repeat;
		position: relative;
		font-size: .24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	.news-main {
		flex: 1;
		padding: 0 .2rem;
	}

	.news-read-count {
		height: .28rem;
		font-size: .2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #969799;
		line-height: .28rem;
		margin-right: .2rem;
	}

	.news-top {
		height: .32rem;
	}

	.news-type {
		height: .32rem;
		background: linear-gradient(96deg, #0091FF 0%, #F4FAFF 100%);
		border-radius: 0px 1rem 1rem 0px;
		font-size: .2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: .32rem;
		text-align: center;
		padding: 0 .12rem;
	}

	.news-type-pic {
		background: linear-gradient(96deg, #F8D77F 0%, #F4FAFF 100%);
	}

	.news-type-video {
		background: linear-gradient(96deg, #0091FF 0%, #F4FAFF 100%);
	}

	.news-item {
		width: 3.45rem;
		/* height: 510rpx; */
		background: #FFFFFF;
		border-radius: .16rem;
		margin-bottom: .2rem;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		padding-top: .16rem;
		padding-bottom: .1rem;
	}



	.show-two-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.show-one-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}

	.flex-start {
		display: flex;
		align-items: center;
	}

	.flex-between {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// NewsItem.vue?7ccacca6